var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWithdraw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4983_61460)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 10h4V1H1v9h4V6H4a.5.5 0 010-1h16a.5.5 0 010 1h-1v4zM6 23h12V6H6v17zM.5 0h23a.5.5 0 01.5.5v10a.5.5 0 01-.5.5H19v12a1 1 0 01-1 1H6a1 1 0 01-1-1V11H.5a.5.5 0 01-.5-.5V.5A.5.5 0 01.5 0zm8.854 13.146a.502.502 0 00-.708 0 .502.502 0 000 .708l3 3a.502.502 0 00.708 0l3-3a.502.502 0 00-.708-.708L12 15.793l-2.646-2.647z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4983_61460"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
SvgWithdraw.displayName = 'Withdraw';
export default SvgWithdraw;